import { Status } from "@common/models";
import { Process } from "./";

export class Section {
    id: Number;
    name: string;
    nameEnglish?: string;
    process: Process;
    status: Status;
    createdAt: Date;
    createdUserId: Number;
    updatedAt: Date;
    updatedUserId: Number;
}
